import React from 'react';
import { useTranslation } from 'react-i18next';
import { SvodDeepLink } from '../../../components/ATS/ats-deep-links/svod-deep-link';
import { SvgCart } from '../../../icons';
import { SvodSource } from '../../../queries/ats/titles/types/sources';
import { getAltiboxServiceUrl } from '../../../utils/svodUtil';
import { CallToAction } from './call-to-action-button';

export interface SvodSourceDeepLinkProps {
  source: SvodSource;
  subtitle?: string;
}

export function SvodServiceLink({ source, subtitle }: SvodSourceDeepLinkProps) {
  const { t } = useTranslation();

  return (
    <SvodDeepLink providerIdentifier={source.providerIdentifier} providerName={source.name}>
      <CallToAction
        text={{
          primary: t('details:get-access'),
          secondary: subtitle,
        }}
        image={{
          src: source.image,
          alt: source.name,
        }}
        icon={<SvgCart />}
        href={getAltiboxServiceUrl(source.providerIdentifier)}
      />
    </SvodDeepLink>
  );
}
